import { LinearGradient } from 'expo-linear-gradient';
import React, { useEffect, useRef, useState } from 'react';
import { View, Image, ActivityIndicator, FlatList } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import OrderCard from '../../Componentsv1/OrderCard';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { market_bulkGetOrders, market_getOrderByOrderId } from '../../store/actionsv1/markets';
import { PlayerReferralProps, PromoProps, PublicPlayerProps } from '../../store/types/auth_svc';
import { OrderProps } from '../../store/types/mk_svc';
import html2canvas from 'html2canvas';
import { player_getReferralByPlayerId } from '../../store/actionsv1/player';
import Switch from './components/Switch';
import TagOrdersModal from './components/TagOrdersModal';
import { Icon } from 'react-native-elements';



const ShareableScreen = ({ route, navigation }:any) => {
    const [ loading, setLoading ] = useState(false);
    const [ select_orders_visible, setSelectOrdersVisible ] = useState(false);
    const [ selected_orders, setSelectedOrders ] = useState<{updated:number, orders:string[]}>({updated:1, orders:[]})
    const [ position_width, setPositionWidth ] = useState(0)
    const [ share_in_process, setShareInProcess ] = useState(false);
    const [ hide_values, setHideValues ] = useState(false)
    const dispatch = useDispatch()

    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    //const orders_state:{updated:number, orders:OrderProps[]} = useSelector((state:any) => state.player.orders, (left, right) => left.updated == right.updated)
    //const orders = orders_state.orders;
    const orders:OrderProps[] = useSelector((state:any) => state.social.viewing_orders.filter((o:OrderProps) => selected_orders.orders.map(id => id.toString()).includes(o.order_id.toString())), (left, right) => {
        if(left.length != right.length){ return false }
        if(left[0]?.order_id != right[0]?.order_id){ return false }
        return true
    });
    const compact = orders.length > 1 ? true : false
    const player_referral:PlayerReferralProps | undefined = useSelector((state:any) => state.player.player_referral, (left, right) => left?.player_referral_id == right?.player_referral_id)
    const promo:PromoProps |undefined = useSelector((state:any) => state.player.promo, (left, right) => left?.promo_id == right?.promo_id)


    useEffect(() => {
        if(route.params?.order_id){ setSelectedOrders({ ...selected_orders, updated:selected_orders.updated +1, orders: [route.params.order_id]}) }
        getReferralFromServer()
    },[route.params?.order_id])


    const getReferralFromServer = async() => {
        if(!player){ return }
        if(!player_referral){ await dispatch(player_getReferralByPlayerId(player.player_id)) }
    }

    useEffect(() => {
        getSelectedOrdersFromServer(selected_orders.orders)
    },[selected_orders.updated])

    const getSelectedOrdersFromServer = async(order_ids:string[]) => {
        if(!player){ return }
        setLoading(true);
        let needed_orders:string[] = []
        order_ids.map(id => {
            let exist = orders.find(o => o.order_id == id)
            if(exist){ return }
            needed_orders.push(id)
        })
        if(needed_orders.length == 0){ return setLoading(false) }
        await dispatch(market_bulkGetOrders(needed_orders))
        setLoading(false)
    }

    useEffect(() => {
        if(!share_in_process){ return }
        html2canvas(imageRef.current).then(function(canvas) {
            var myImage = canvas.toDataURL("image/png");
            share(myImage)
        });
    },[share_in_process])

    const getImage = async() => {
        if(!imageRef?.current){ return alert('Nothing to capture') }
        setShareInProcess(true)
    }

    const share = async(newImage:string) => {
        if(!player){ return }
        let text = 'Check out my positions @BettorEdge ';
        if(orders.length == 1){
            text = `I got ${orders[0].title}! Follow me on @Bettoredge `
        }
        setShareInProcess(false)
        if(!newImage){ return alert('No image!') }
        if(!navigator?.share){ return alert('Browser does not support sharing')}
        const blob = await (await fetch(newImage)).blob();
        const filesArray = [
            new File([blob], `${player.player_id}_position.png`, { type:blob.type } )
        ]
        navigator.share({ text, files:filesArray }).then(() => {
            //segEventTrack({ event: 'Shared Position', properties: { be_type:route.params.be_type, result:shareablePosition.result_ind } })
        }).catch((e) => console.log(e))
    }

    const renderShareableOrders = (data: {item:string, index:number}) => {
        let order = orders.find(o => o.order_id == data.item)
        if(!order){ return <></> }
        return (
            <View style={{ padding:5 }}>
                <OrderCard 
                    order={order}
                    view_mode='share'
                    hide_values={hide_values}
                    compact={compact}
                />
            </View>
        )
    }

    const imageRef = useRef();
    const aspectRatio = 36.16/155
    const imageHeight = position_width * 0.3 * aspectRatio


    
    if(loading){
        return (
            <View style={{flex:1, backgroundColor:Colors.brand.midnight, justifyContent:'center', alignItems:'center'}}>
                <ActivityIndicator size='large' color={Colors.shades.white} />
            </View>
        )
    }

    let promo_amount = 0
    if(promo?.amount){
        promo_amount = promo.amount
    }
    return (
        <View nativeID='shareable-position' ref={imageRef} style={{ flex:1 }}>
            <LinearGradient colors={['#003566','#005FB7']} style={{ flex:1, backgroundColor:Colors.brand.midnight, padding:10, justifyContent:'space-between'}}>
                {share_in_process ?
                <View />
                :
                <View nativeID='select_orders' style={{ alignItems:'flex-end' }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', backgroundColor:Colors.shades.white, borderRadius:8 }} onPress={() => setSelectOrdersVisible(true)}>
                        <Icon name='plus' type='feather' raised size={16} color={Colors.brand.electric} />
                        <Text style={{ marginLeft:5, marginRight:5 }} size={14} color={Colors.brand.electric} weight='semibold'>Add Orders / Positions!</Text>
                    </TouchableOpacity>
                </View>
                }
                <View onLayout={(ev) => {
                    setPositionWidth(ev.nativeEvent.layout.width)
                }}>
                    <View nativeID='shareble_orders' style={{ backgroundColor:compact?Colors.shades.white:'transparent', borderRadius:4, paddingTop:5 }}>
                            <FlatList
                                data={selected_orders.orders}
                                renderItem={renderShareableOrders}
                            />
                        </View>
                        {orders.length > 0 ?
                        <View style={{marginTop:5, marginLeft:20, marginRight:20, flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                            <Text size={14} color={Colors.shades.white} weight='regular'>app.bettoredge.com</Text>
                            <Text size={14} color={Colors.shades.white} weight='regular'>@bettoredge</Text>
                        </View>
                        :<></>}
                    {player_referral ?
                    <>
                    {promo?.type === 'referral_code' ?
                    <Text size={20} color={Colors.shades.white} textAlign='center' weight='semibold' style={{margin:20, marginRight:40, marginLeft:40}}>JOIN WITH MY CODE AND GET ${promo_amount > 0?promo?.amount:'$$$'}</Text>
                    :promo?.type === 'referral_sweepstakes' ?
                    <Text size={20} color={Colors.shades.white} textAlign='center' weight='semibold' style={{margin:20, marginRight:40, marginLeft:40}}>JOIN WITH MY CODE AND GET UP TO $500</Text>
                    :<></>}
                    <View style={{justifyContent:'center', alignItems:'center'}}>
                        <View style={{backgroundColor:Colors.shades.white, borderRadius:4, padding:15, paddingTop:5, paddingBottom:5}}>
                            <Text size={26} weight='semibold' color={Colors.brand.electric} textAlign='center'>{player_referral.referral_code}</Text>
                        </View>
                    </View>
                    </> : <></>}
                    {orders.length > 0 ?
                    <View style={{ position:'absolute', top:-40, right:0, left:0, justifyContent:'center', alignItems:'center' }}>
                        <LinearGradient style={localStyles.brandStyle} colors={['#005FB7', '#08A4BD']}
                        start={[0,0]} end={[1,0]}>
                            <Image source={require('../../assets/images/be_logo_long.png')} style={{width:position_width*0.3, height:imageHeight}}/>
                        </LinearGradient>
                    </View>
                    :<></>}
                </View>
                {!share_in_process ?
                <View style={{justifyContent:'center', alignItems:'center'}}>
                    <View style={{flexDirection:'row', alignItems:'center', borderRadius:20, backgroundColor:Colors.shades.white, padding:5, paddingLeft:15}}>
                        <Text size={12} color={Colors.brand.midnight} weight='regular'>Hide $ Values</Text>
                        <View style={{paddingRight:12, paddingLeft:10, borderRightWidth:1, borderColor:Colors.shades.shade600}}>
                            <Switch value={hide_values} switch_type={'on_off'} onChange={(value:boolean) => setHideValues(value)}/>
                        </View>
                        <TouchableOpacity style={{ marginLeft:12, borderRadius:20, backgroundColor:Colors.utility.error, padding:6, paddingRight:20, paddingLeft:20 }} onPress={() => navigation.goBack()}>
                            <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>BACK</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ marginLeft:5, borderRadius:20, backgroundColor:Colors.brand.cyan, padding:6, paddingRight:20, paddingLeft:20 }} onPress={() => getImage()}>
                            <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>SHARE</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                :<View />}
            </LinearGradient>
            <TagOrdersModal
                isVisible={select_orders_visible}
                onTagOrders={(orders) => setSelectedOrders({ ...selected_orders, updated:selected_orders.updated +1, orders: orders}) }
                init_orders={selected_orders.orders}
                closeModal={() => setSelectOrdersVisible(false)}
            />
        </View>   
    )
}


const localStyles = {
    brandStyle : { padding:15, paddingRight:25, paddingLeft:25, borderRadius:10, shadowColor: "#002A51", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.25, shadowRadius: 3.84, elevation: 5 } 
}

export default ShareableScreen